// 请保证所有语言包 的Key值都一直
export default {
  login: {
    username: '用户名',
    password: '密码'
  },
  menu: {
    Menu_ItemList: '项目列表',
    Menu_ToDoList: '待办列表',
    Menu_Drafts: '草稿箱'
  },
  common: {
    welcome: '欢迎您',
    upload: '上传',
    download: '下载',
    save: '保存',
    saveDraft: '保存草稿',
    submit: '提交',
    view: '查看',
    delete: '删除',
    edit: '编辑',
    search: '查询',
    reset: '重置',
    export: '导出',
    discard: '废弃',
    audit: '审核',
    preReturnBtn: '返回',
    uploadtip: '最大30M'
  },
  message: {
    unbound: '当前账号未关联有效合作伙伴身份，请确保合作伙伴签约记录仍然处于有效期内且账号已被绑定，如有疑问请联系锐捷销售',
    prompt: '请输入至少2个字符',
    registrationNo: '输入注册号',
    hints: '如果项目已经丢标或者该项目不需要再保护，请点击项目废弃',
    deleteConfirm: '确认要删除吗?',
    discardConfirm: '确认要废弃吗?',
    cancel: '取消',
    comfirm: '确认',
    deletesuccess: '删除成功',
    setDepartment: '请联系管理员设置部门',
    operation: '操作',
    queryResult: '查询结果',
    needPartnerName: '请输入合作伙伴名称',
    needProjectName: '请输入项目名称',
    needRuijieSaleName1: '请输入锐捷销售',
    needCountry: '请输入项目所属国家',
    needFinalCompanyName: '最终用户公司名称',
    needFinalCompanyAddress: '请输入最终用户公司地址',
    needFinalUserName: '请输入最终用户项目负责人',
    needFinalUserPosition: '请输入最终用户项目负责人职位',
    needFinalUserTel: '请输入决策者的电话号码',
    needFinalUserEmail: '请输入决策者邮箱',
    needFundsInPlace: '请选择资金是否已到位',
    needProjectBudget: '请输入项目整体预算',
    needNetworkBudget: '请输入网络产品部分预算',
    needPurchaseTime: '请选择采购时间点',
    needExpectedOrderDate: '请选择预期下单时间',
    needIsSupportRuijie: '请选择最终用户项目负责人是否支持锐捷',
    needHasCooperated: '请选择以前是否合作过',
    needRuijieSaleName: '请选择锐捷销售',
    needProjectRequirements: '请输入用户项目需求',
    needEmail: '请输入邮箱',
    needBeEmail: '请输入正确的邮箱格式',
    needPartnerEmail: '请输入渠道负责人邮箱',
    needPartnerContactName: '请输入渠道联系人姓名',
    needPartnerPhone: '请输入渠道联系人电话',
    needJointVisit: '请选择是否可以安排联合拜访',
    needProjectPhase: '请选择项目阶段',
    unitOfCash: 'USD',
    saveSuccess: '保存成功',
    submitSuccess: '提交成功',
    submitError: '提交失败',
    select: '请选择',
    agree: '同意',
    reject: '驳回',
    rejectToFirst: '驳回到第一步',
    needOpinion: '请输入审核理由',
    needDiscardReason: '请输入废弃原因',
    discardSuccess: '废弃成功',
    clause: '报备须知条款',
    close: '关闭',
    readyAndAgree: '我已阅读并同意锐捷国际合作伙伴项目保护条款。',
    pleaseReadAndAgreeClause: '请先阅读并同意锐捷国际合作伙伴项目保护条款。',
    budgetNotAllow: '请输入12位以内的正数',
    budgetCantNegative: '预算金额不能为负数',
    needNumberType: '请输入数字类型',
    enterProjectName: '输入项目名称进行查询',
    enterFinalUserName: '输入最终用户姓名进行查询',
    enterFinalCompanyAddress: '输入项目实施地址进行查询',
    approver: '审批人',
    logout: '注销'
  },
  page: {
    drafts: '草稿箱',
    addProject: '新建项目',
    list: '项目列表',
    todoList: '待办列表',
    projectSearch: '搜索注册项目',
    prmNew: {
      title: '新建项目',
      partnerName: '合作伙伴名称',
      projectName: '项目名称',
      country: '项目所属国家',
      finalCompanyName: '最终用户公司名称',
      finalCompanyAddress: '项目实施地址',
      finalUserName: '最终用户项目负责人',
      finalUserPosition: '最终用户项目负责人职位',
      finalUserTel: '最终用户项目负责人电话',
      finalUserPhone: '最终用户项目负责人手机号码',
      finalUserEmail: '最终用户项目负责人E-Mail',
      fundsInPlace: '资金是否已到位',
      projectBudget: '项目整体预算',
      networkBudget: '网络产品部分预算',
      expectedOrderDate: '预期下单时间',
      isSupportRuijie: '最终用户项目负责人是否支持锐捷?',
      ruijieSaleName: '锐捷销售',
      hasCooperated: '以前是否合作过',
      projectPhase: '这个项目在哪个步骤',
      projectPhases: '这个项目在哪个步骤',
      expctedOrderDate: '过期订单日期',
      lastUpdata: '最后更新数据',
      projectRequirements: '用户项目需求',
      budgetFrom: '预算来源',
      executiveDepartment: '哪个部门已经或将要启动这个项目?',
      participatingDepartment: '哪个部门已经或将要加入这个项目?',
      dockingPeople: '谁可以成为我们的顾问或支持者，什么头衔?',
      competitorSituation: '竞争对手情况',
      beforeSell: '之前您向这个最终用户销售了哪些产品',
      projectAttachment: '本项目产品清单',
      projectAttachmentDetail: '项目配置清单',
      partnerEmail: '合作伙伴报备联系人邮箱',
      partnerContactName: '合作伙伴报备联系人姓名',
      partnerPhone: '合作伙伴报备联系人电话',
      projectContractor: '项目承包商（ELV项目）',
      relatedRAP: '相关RAP',
      jointVisit: '是否可以安排联合拜访?',
      fillFullName: '请填写全名，不要缩写'
    },
    prmList: {
      projectStep: '项目步骤',
      registration: '登记',
      partnerName: '合作伙伴名称',
      projectName: '项目名称',
      country: '项目所属国家',
      ruijieSaleName: '销售',
      taxNumber: '税号',
      approvalState: '审核节点',
      prmState: '状态',
      discardReason: '废弃原因',
      showClauseSBG: '查看SBG报备须知条款',
      showClauseEBG: '查看EBG报备须知条款',
      applicant: '申请人',
      submitTime: '提交时间'
    },
    prmDetail: {
      contentTitle: '项目信息',
      approvalTitle: '审批记录',
      approvalNode: '审核节点',
      operator: '操作人',
      auditStatus: '状态',
      approvalDate: '审核时间',
      approvalRemarks: '审批说明',
      operatorLogTitle: '操作日志',
      operation: '操作内容',
      fieldName: '字段名称',
      oldValue: '旧值',
      newValue: '新值',
      updateTime: '更新时间',
      operationType: '操作类型',
      endUserInfo: '最终用户信息',
      partnerInfo: '合作伙伴信息'
    },
    prmEdit: {
      title: '编辑'
    },
    prmAudit: {
      title: '审核',
      remarksApproval: '审批说明'
    },
    prmView: {
      title: '查看'
    },
    ProjectSearch: {
      result: '结果',
      country: '国家/地区',
      sales: '销售',
      email: '电子邮件'
    }
  }
};
